import dynamic from "next/dynamic";
const MultiCardsCarouselTabsComponent = dynamic(()=>import("./multi-cards-carousel-tabs-component"));
import MultiCardsCarouselTabsConfig from "./multi-cards-carousel-tabs-config";
import MultiCardsCarouselTabsAdvancedConfig from "./multi-cards-carousel-tabs-advanced-config";
export default {
    MultiCardsCarouselTabsComponent,
    MultiCardsCarouselTabsConfig,
    MultiCardsCarouselTabsAdvancedConfig
};
